export class Status {

  public static EMPTY = new Status();

  public id = "";
  public text = "";
  public textColor = "";
  public backColor = "";

  public isEmpty(){
    return this.id === "";
  }

  public clone(): Status{
    const clone = new Status();
    clone.id = this.id;
    clone.text = this.text;
    clone.textColor = this.textColor;
    clone.backColor = this.backColor;
    return clone;
  }
}
